import { Close, Done } from '@mui/icons-material'

import { Column, Filter } from '../table/base'
import { LowLatencyHostInfo } from './types'

export const LOW_LATENCY_HOSTS_DGE_TABLE_COLUMNS: Column<LowLatencyHostInfo>[] = [
  {
    id: 'id',
    type: 'text',
    label: 'ID',
    sortAttribute: 'id'
  },
  {
    id: 'displayName',
    type: 'text',
    label: 'Name',
    sortAttribute: 'displayName'
  },
  {
    id: 'host',
    type: 'text',
    label: 'Host',
    sortAttribute: 'host'
  },
  {
    id: 'inUse',
    type: 'component',
    label: 'In Use',
    align: 'center',
    render: (inUse) => {
      return inUse ? <Done color="success" /> : <Close color="error" />
    }
  }
]
export const LOW_LATENCY_HOSTS_FILTERS: Filter<LowLatencyHostInfo>[] = [
  {
    paramName: 'search',
    type: 'freeTextSearch',
    filterOptions(data, search) {
      const lowerCaseSearch = search.toLowerCase()

      return (
        data.displayName.toLowerCase().includes(lowerCaseSearch) ||
        data.host.toLowerCase().includes(lowerCaseSearch) ||
        data.id.toString().includes(lowerCaseSearch)
      )
    }
  }
]
